import createAction from 'Store/utils/createAction';
import { SET_ENTRY_ROUTE, UNSET_ENTRY_ROUTE } from './entryRoute.reducer';
export const setEntryRoute = (payload: string) => createAction(SET_ENTRY_ROUTE, payload);
export const unsetEntryRoute = () => createAction(UNSET_ENTRY_ROUTE);
